import React, { useContext } from 'react'

// @mui core components
import { Box, Grid, Typography, Button } from '@mui/material'
import Card from 'atoms/Card'

// Data
import { IntakeContext } from 'context/IntakeContext'
import { selectData } from 'layouts/onboarding'

// Popup
import { toast } from 'react-toastify'

import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

// Debounce
import { useFormDebounce } from 'hooks/useFormDebounce'
import LoadingButton from 'components/LoadingButton'

function Retirement() {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()

  const showSurvivorBenefit = intakeState?.familyMaritalStatus === 'married'
  const showSurvivorBenefitOwed = intakeState?.familyDivorcedOwedPension
  const isGovernmentEmployee = intakeState?.governmentEmployee

  // add an onSubmit button and call the context function `updateUser`
  // const onSubmit = () => updateUser()
  const onSubmit = async () => {
    await updateUser()
    toast.info('You have successfully updated your Retirement details', {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }

  return (
    <>
      <Box
        pl={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography display="flex" align="left" variant="body2FunHeader">
          RETIREMENT
        </Typography>

        <LoadingButton loading={loading} onClick={onSubmit} />
      </Box>
      <Card>
        <Box component="form" p={3}>
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                autoFocus: false,
                id: 'retirementSystem',
                label: 'Retirement System',
                placeholder: '',
                inputType: 'select',
                value: intakeState.retirementSystem,
                onChange: updateIntakeStateAndSubmit((retirementSystem) =>
                  updateIntakeStateAtKey({ retirementSystem })
                ),
                options: selectData.retirementSystem,
              })}
            </Grid>
            {showSurvivorBenefit && isGovernmentEmployee ? (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'survivorBenefitElection',
                  label: 'Survivor Benefit Election',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.survivorBenefitElection,
                  onChange: updateIntakeStateAndSubmit(
                    (survivorBenefitElection) =>
                      updateIntakeStateAtKey({ survivorBenefitElection })
                  ),
                  options: selectData.survivorBenefitElection,
                })}
              </Grid>
            ) : (
              <></>
            )}
            {showSurvivorBenefitOwed && isGovernmentEmployee ? (
              <Grid item xs={12} sm={6}>
                {renderMuiFormField({
                  autoFocus: false,
                  id: 'familyDivorcedOwedPension',
                  label: 'Survivor Benefit Owed to Former Spouse',
                  placeholder: '',
                  inputType: 'select',
                  value: intakeState.familyDivorcedOwedPension,
                  onChange: updateIntakeStateAndSubmit(
                    (familyDivorcedOwedPension) =>
                      updateIntakeStateAtKey({ familyDivorcedOwedPension })
                  ),
                  options: selectData.survivorBenefitElection,
                })}
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        </Box>
      </Card>
    </>
  )
}

export default React.memo(Retirement)
